import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'

const SubHeader = (props) => {
  const { boxProps, children } = props

  return (
    <Box
      alignItems="center"
      minHeight={80}
      padding="large"
      style={{ boxShadow: '1px 1px 10px rgba(0, 0, 0, 0.05)' }}
      {...boxProps}
    >
      {children}
    </Box>
  )
}

SubHeader.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default SubHeader
